package com.downdogapp.client

/**
 * AUTO-GENERATED DO NOT EDIT!
 * from com.downdogapp.tasks.AppStrings
 */
// @formatter:off 
object EnglishStrings : LanguageStrings {
  // https://worker.downdogapp.com/debug/appString?appStringId=488
  override fun ABBREVIATED_MEMBERSHIP_WILL_NOT_RENEW(p0: Any) = "Canceled, expiring ${p0}"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=498
  override val ACCOUNT = "Account"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=2588
  override val ACCOUNT_INELIGIBLE_FOR_REFERRAL_MESSAGE = "Looks like you already have an account!  Only new accounts are eligible for free membership from referral.  Sorry!"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1467
  override val AFFILIATE_ANSWER = "Thank you for your interest!  We have discontinued our affiliate program, so unfortunately not.  Sorry!"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1466
  override val AFFILIATE_QUESTION = "Do you have a referral or affiliate program?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1299
  override val AFFORDABILITY = "Affordability"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1300
  override val AFFORDABILITY_FEEDBACK_PROMPT = "Tell us about your situation"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=518
  override val AFFORDABILITY_MESSAGE = "Our mission is to provide great affordable fitness to the world. If Down Dog isn't in your budget right now, send us a message explaining your situation and we'll see what we can do!"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3950
  override val AIRPLAY = "Airplay"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1409
  override val AIRPLAY_ANSWER = "You can AirPlay your Down Dog practice using screen mirroring! For more information, go to <a href=\"https://support.apple.com/en-us/HT204289\">Apple's support page</a>"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1408
  override val AIRPLAY_QUESTION = "Do you support AirPlay?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1292
  override val ALL = "All"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1255
  override val ALL_APPS = "All Apps"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1453
  override val ALL_APPS_PURCHASE_ANSWER = "At this time, subscription purchases give you access to all of our apps, including Down Dog Yoga, HIIT, Barre, Prenatal Yoga, and Meditation! \n\nWe do not currently offer the option to purchase a single app."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1452
  override val ALL_APPS_PURCHASE_QUESTION = "Is my subscription for one app or all apps?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3110
  override val ALL_POSES = "All Poses"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1295
  override fun AMOUNTS_CURRENCY_PAYMENTS_SECURE_MESSAGE(p0: Any) = "All amounts shown in ${p0}. Your payment data is encrypted and secure.\n"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=113
  override val AND = "and"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1589
  override val APPLE = "Apple"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1403
  override val APPLE_HEALTH_ANSWER = "Yes!  If you are having trouble connecting, here are some tips:\n1. Check that your app is connected to Health.  Open the app and navigate to the menu (hit the three horizontal lines button in bottom right), is there an option to Connect To Apple Health?  If so, click that option.\n2. Open the Health App on your phone, and click the data sources tab.  Is Down Dog listed as a data source?  This is to double check Down Dog is connected.  If it isn't (but there was no option to connect within Down Dog), let us know!\n3. Try uninstalling and reinstalling the app, and then logging in and reconnecting to Apple Health.\n\nUnfortunately, Apple Health isn't supported on iPad, and we don't support tracking your practices across devices (although we may some day)."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1402
  override val APPLE_HEALTH_QUESTION = "Do the apps connect to Apple Health?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1420
  override fun APPLE_REFUND_POLICY(p0: Any) = "Unfortunately, Apple doesn't let us cancel or refund subscriptions that were purchased through the App Store. Here's some instructions from Apple for how to cancel your subscription: ${p0}"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1425
  override val ASK_IN_FACEBOOK_GROUP = "Ask in the Facebook group"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=490
  override val AUTO_RENEW_IS_OFF = "Auto-Renew Off"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=489
  override val AUTO_RENEW_IS_ON = "Auto-Renew On"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1221
  override val AUTO_RENEW_OFF_ANSWER = "<b>How to Manage or Cancel Your Subscription</b>\n\nIf you purchased your subscription <em>on the web</em>:\n1. Go to <b>Settings</b>. On mobile, you can get there by tapping the three horizontal lines at the bottom right of the screen. On web, Settings is in the left sidebar. \n2. Under <b>Settings</b>, tap <b>Subscription</b>.\n3. Then you should see more info, including how to cancel or change your subscription, including turning off auto-renew.\n\nIf you purchased your subscription <em>through the mobile app</em> you can manage your subscription through the <a href=\"https://support.apple.com/en-us/HT202039\" target=\"_blank\">Apple App Store</a> or through the <a href=\"https://support.google.com/googleplay/answer/7018481?co=GENIE.Platform%3DAndroid&hl=en\" target=\"_blank\">Google Play Store</a>. \n\n<b>About Your Subscription</b>\n\nYou will never be charged for a subscription unless you explicitly purchase a membership through our website, Apple, or Google. Subscriptions are found under the email address that you used when you purchased the subscription. If you do not see a subscription listed in your account, it means you do not have a subscription associated with the email address you currently logged in with. It is possible that your subscription may be associated with another email address, and if that is the case, you will need to log out and then log back in under that email address to see your subscription.\n"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1211
  override val AUTO_RENEW_OFF_QUESTION = "I want to disable auto-renew."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=252
  override val BACK = "Back"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=787
  override val BARRE = "Barre"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=759
  override val BARRE_GOOGLE_FIT_DESCRIPTION = "Barre Workout"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1432
  override val BILLING = "Billling"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1258
  override val BILLING_REFUND = "Billing - refund"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=332
  override val BREATHING = "Breathing"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=2538
  override val BREATHING_GOOGLE_FIT_DESCRIPTION = "Breathwork Practice"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=263
  override val CANCEL = "Cancel"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=2564
  override val CANCEL_DOWNLOAD = "Cancel Download"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1470
  override val CANNOT_MERGE_ACCOUNTS_ANSWER = "Unfortunately, we cannot merge your accounts. \n\nPlease make sure to sign in with the email you used when purchasing your subscription to get access!"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1469
  override val CANNOT_MERGE_ACCOUNTS_QUESTION = "I have more than one account. Can I merge them?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1305
  override val CANT_ACCESS_SUBSCRIPTION_ANSWER = "You likely created multiple Down Dog accounts by accident. You should try logging out of the app and logging back in with any other email addresses you may have used. Please note that your subscription works across all of our apps and on all of your devices (including the web version), but you must be signed in with the same email you used to make the purchase. <em>Note that Apple, Google, and PayPal may have sent receipts to the email address you have associated with those services, and not the email address you used to log into Down Dog</em>.\n\nIf you subscribed from within the mobile app using Apple iTunes or Google Play, you should try clicking <b>Restore In-App Purchase</b> from the menu of the app. Be sure to do this from within the same app in which you made the original purchase.\n\nIf you subscribed via PayPal and you don't have access to your subscription, your payment most likely did not succeed. You can check this from within your PayPal account, or by visiting the Settings of the app where you will see a subscription that only lasts a few days. If this is the case, you were not actually charged and you can attempt to make the purchase again by visiting our website. You may have more success paying with a credit card directly rather than using PayPal.\n"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1304
  override val CANT_ACCESS_SUBSCRIPTION_QUESTION = "I can't access my subscription."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3949
  override val CAST = "Cast"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1203
  override val CAST_ANSWER = "Yes, we recently added Chromecast support in the mobile and web apps!\n\nHere's how to use Chromecast in the mobile app: \n1. Make sure your chromecast-enabled device (such as a TV) is turned on and is on the same WiFi network as your Android/iOS device, and also make sure you have the latest version of the app. \n2. Start a practice. \n3. Tap the screen to bring up the controls, then tap the <b>Chromecast button</b> in the top right (it looks like a rectangle with three quarter-circles in the bottom corner). \n4. Wait up to a minute for the practice to load on your TV, then click play on your Android/iOS device. \n\nAnd here's how to use Chromecast on the web app: \n1. Make sure your chromecast-enabled device (such as a TV) is turned on and is on the same WiFi network as your computer. \n2. Start a practice in the web app, using <b>Chrome</b>. \n3. Click the <b>Chromecast button</b> in the bottom right (iIt looks like a rectangle with three quarter-circles in the bottom corner). \n4. Wait up to a minute for the practice to load on your TV, then click play on your computer."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1191
  override val CAST_QUESTION = "Do you support Chromecast?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1349
  override val CAST_TROUBLESHOOTING_ANSWER = "<b>If your CAST BUTTON is not showing up:</b> \n\n1. Start a practice, then pause. Do you see the cast button (top right corner for Android/iOS; bottom right corner for the web app)? We only show the cast button during a practice. \n\n2. Try casting something else (e.g. YouTube) from the same device. Do you see a cast button then? If not, make sure your chromecast-enabled device (such as a TV) is turned on and is on the same WiFi network as your computer or your Android/iOS device. If you're on a computer, make sure you're using Chrome. \n\n3. Try casting from a different device. If you were using Android/iOS, try casting from the web app on your computer, and vice versa. \n\n4. Try turning off battery optimization for the Down Dog app(s) on your phone. This will let the app keep communicating with your Chromecast device, instead of going into power saving mode after a few minutes of inactivity. \n\n\n<b>If you're \"CONNECTED\" but the video doesn't play:</b> \n\nFirst, make sure that you're waiting long enough for Down Dog to load on your TV. Loading can take up to 60 seconds. During this time your TV will initially show a yellow \"loading\" bar across the bottom, then fade to black. Your TV will show the video once it has finished loading. \n\nIf your TV screen is still black after 60 seconds, or if the words \"Down Dog\" appear in the middle of a black screen, exit your practice and try again. You can restart the same practice from the History tab (the clock icon at the bottom of your screen for Android/iOS; in the left sidebar for web). \n\n\n<b>If your cast DISCONNECTS after a few minutes of playback:</b> \n\n1. Check your WiFi signal strength. If your Chromecast or phone/computer has a weak signal, you can improve the signal strength using a WiFi extender or by moving it closer to your router.\n\n2. Turn off battery optimization for the Down Dog app(s) on your phone. This will let the app keep communicating with your Chromecast device, instead of going into power saving mode after a few minutes of inactivity. \n\n3. If that doesn't fix the issue, you can also try restarting your router.\n\n4. Finally, try editing your phone's stored wifi connection settings to use a static IP address.\n"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1348
  override val CAST_TROUBLESHOOTING_QUESTION = "I'm having trouble with Chromecast."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=997
  override fun CASTING_TO_DEVICE(p0: Any) = "Casting to ${p0}"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3302
  override val CHALLENGE_EMAIL_NOTIFICATIONS_TEXT = "Email"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3470
  override val CHALLENGE_EMAIL_UPDATES_TEXT = "Email"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3468
  override val CHALLENGE_ENROLL_CHALLENGE_UPDATES_SUBHEADER = "Challenge Updates"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3469
  override val CHALLENGE_ENROLL_CHALLENGE_UPDATES_SUBTEXT = "Get updates on the community and your challenge progress!"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3466
  override val CHALLENGE_ENROLL_DAILY_REMINDERS_SUBHEADER = "Daily Reminders"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3467
  override val CHALLENGE_ENROLL_DAILY_REMINDERS_SUBTEXT = "Get reminders to practice every day in January!"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3809
  override val CHALLENGE_FAQ_A1 = "A: To complete the challenge, you must complete a practice every day of the month. You can use any Down Dog app. Practices must be completed in full."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3811
  override val CHALLENGE_FAQ_A2 = "A: Down Dog will track your progress using the calendar on the Journey page of your app! Every day when you practice and you see the calendar date in blue, it is tracked towards your challenge progress. "
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3814
  override val CHALLENGE_FAQ_A3 = "A: We send our daily reminders based on the time you practiced the day before. So if you practiced earlier than you normally would you may have beat us to it! As long as you see your practices tracked on the calendar on your Journey page they count towards your challenge progress."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3816
  override val CHALLENGE_FAQ_A4 = "A: No. We’re very sorry but we can’t add practices to your history that were not completed on a Down Dog app."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3818
  override val CHALLENGE_FAQ_A5 = "A: If you're traveling and changing time zones, this might affect your challenge streak. Currently, our system records your practice history based on the time zone you're in at the time of practice. This means your practice dates will align with your current time zone, not your original one. To maintain your streak, we recommend practicing at a time that aligns with your original time zone whenever possible."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3820
  override val CHALLENGE_FAQ_A6 = "A: Winners are selected randomly from the group of users who complete the challenge. Winners are contacted individually at the end of the challenge. "
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3808
  override val CHALLENGE_FAQ_Q1 = "Q: What are the requirements? "
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3810
  override val CHALLENGE_FAQ_Q2 = "Q: How is my progress tracked? "
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3813
  override val CHALLENGE_FAQ_Q3 = "Q: I am signed up for daily notifications but didn’t get one today, is something wrong? "
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3815
  override val CHALLENGE_FAQ_Q4 = "Q: I completed a practice somewhere else - can it be added to my app history? "
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3817
  override val CHALLENGE_FAQ_Q5 = "Q: I’m traveling during the challenge. Will that affect anything? "
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3819
  override val CHALLENGE_FAQ_Q6 = "Q: How are merch winners selected & contacted?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3807
  override val CHALLENGE_FAQ_TITLE = "Down Dog Challenge FAQ"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3465
  override val CHALLENGE_NO_MESSAGING_ENABLED_ALERT_TEXT = "You've chosen not to receive any communications, so you won't receive any progress updates or reminders from Down Dog about the challenge."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3471
  override val CHALLENGE_NO_MESSAGING_ENABLED_ALERT_TITLE = "Are you sure?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3303
  override val CHALLENGE_PUSH_NOTIFICATIONS_TEXT = "Push Notifications"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3317
  override val CHALLENGE_RESUBSCRIBE_TO_EMAILS_ALERT_TEXT = "Heads up!  You previously opted out of receiving email communications from Down Dog.  By enabling email communication within the challenge, we will automatically re-enable your account to receive email communications from us."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1218
  override val CHANGE_EMAIL_ANSWER = "1. Go to <b>Settings</b>. On mobile, you can get there by tapping the three horizontal lines at the bottom right of the screen. On web, Settings is in the left sidebar. \n2. Under <b>Account</b>, tap <b>Email</b> and fill in the email you'd like to use\n3. Tap <b>Save</b>"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1208
  override val CHANGE_EMAIL_QUESTION = "How do I change the email associated with my account?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=152
  override val CHANGE_LANGUAGE = "Change Language"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1159
  override val CHANGE_LANGUAGE_ANSWER = "<b>Yoga, Prenatal, Meditation, HIIT</b>\n\nYou can change the language by navigating to <b>Settings</b> (on the mobile app, tap the 3 horizontal lines in the bottom right, and on the web app Settings will be on the left sidebar) and then tap <b>Language</b>! \n\n<b>Barre</b>\n\nCurrently this app is only offered in English. You'll still hear instructions in English even after changing the language."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=327
  override val CHANGE_LANGUAGE_NO_INTERNET_MESSAGE = "Uh oh! You need to be connected to the internet in order to change your language."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1158
  override val CHANGE_LANGUAGE_QUESTION = "How do I change the language I hear?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1219
  override val CHANGE_PASSWORD_ANSWER = "1. Go to <b>Settings</b>. On mobile, you can get there by tapping the three horizontal lines at the bottom right of the screen. On web, Settings is in the left sidebar. \n2. Under <b>Account</b>, tap <b>Password</b> and fill in the new password you'd like to use in the Password and Confirm Password fields \n3. Tap <b>Save</b>\n\nIf you have forgotten your password, just enter your email and an incorrect password at the login screen.  Then, click the <b>Forgot Password?</b> option."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1209
  override val CHANGE_PASSWORD_QUESTION = "How do I change my password?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1142
  override val CHANGE_PLAYLIST_TYPE_ANSWER = "We offer many categories of music and are constantly adding new options!  In the app, you can switch the music style by swiping up the settings view and tapping <b>Music</b>!  On the web version, you can scroll through the settings and click the <b>Music</b> option."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1141
  override val CHANGE_PLAYLIST_TYPE_QUESTION = "How do I change the music?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=52
  override val CHANGE_VISUAL_TYPE_NO_INTERNET_MESSAGE = "Uh oh! You'll need an internet connection to change the visuals for this practice."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1157
  override val CHANGE_VOICE_ANSWER = "<b>Yoga, Prenatal, Meditation, and HIIT</b>\n\nWe currently offer multiple English-speaking voices in these apps.  On mobile, you can change the voice you hear by swiping up on the main settings page, and then tapping on <b>Voice</b>.  On web, you can scroll through the settings and click the <b>Voice</b> option.\n\nWe also offer several non-English speaking voices in these apps.  You can change the language by navigating to <b>Settings</b> (on the mobile app, tap the 3 horizontal lines in the bottom right, and on the web app Settings will be on the left sidebar) and then tap <b>Language</b>!\n\n<b>Barre</b>\n\nThere's only one voice for now, but we plan to add additional languages and voices in the future. "
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1156
  override val CHANGE_VOICE_QUESTION = "How do I change the voice I hear?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1441
  override val CHARGED_TWICE = "I was charged twice."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1433
  override fun CHECK_OUT_QUESTION(p0: Any) = "Check out our ${p0} to see if your question is answered there"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=482
  override val CLEAR_PRACTICE_HISTORY_CONFIRM_MESSAGE = "Are you sure you want to delete all practices from your practice history? This action cannot be undone."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=275
  override val CLOSE = "Close"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1180
  override val COMMUNITY_ANSWER = "We have a vibrant and supportive <a href=\"https://www.facebook.com/groups/183894272193568/\" target=\"_blank\">Down Dog Community</a> on Facebook that you can join to ask for advice and share your progress!  You can also follow us on <a href=\"https://www.instagram.com/downdogapp/\" target=\"_blank\">Instagram</a> to get tips and connect with others who practice with Down Dog!"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1172
  override val COMMUNITY_QUESTION = "I’m craving community during my journey!  Is there some group I can join to support me when I have questions?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1394
  override val COMPANIES_FREE_UNTIL_JUNE_1_LONG = "Work-from-home employees are eligible for free membership through June 1st!"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=2563
  override val CONFIRM_CANCEL_OFFLINE_DOWNLOAD = "Are you sure you want to cancel this download?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=2561
  override val CONFIRM_DELETE_OFFLINE_PRACTICE = "Are you sure you want to delete this offline practice?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=428
  override val CONFIRM_PASSWORD = "Confirm Password"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1
  override val CONNECT_TO_APPLE_HEALTH = "Connect to Apple Health"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=93
  override val CONNECT_TO_GOOGLE_FIT = "Connect to Google Fit"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=2
  override val CONNECTED_TO_APPLE_HEALTH_MESSAGE = "Your practices will now automatically be logged to Apple Health!"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=94
  override val CONNECTED_TO_GOOGLE_FIT_MESSAGE = "Your practices will now automatically be logged to Google Fit!"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1009
  override val CONNECTING_TO_CHROMECAST = "Connecting..."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=25
  override val CONNECTION_PROBLEM = "Connection Problem"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=264
  override val CONTACT = "Contact"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1421
  override val CONTACT_APPLE_FOR_REFUND = "If you want a refund, you should contact Apple support and let them know that we are okay with a refund. "
  
  // https://worker.downdogapp.com/debug/appString?appStringId=265
  override val CONTINUE = "Continue"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=437
  override val CORPORATE_MEMBERSHIP = "Corporate Membership"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=616
  override val COUNTDOWN_TIMER = "Countdown Timer"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=2550
  override val CREATE_OFFLINE_PRACTICE = "Create Offline Practice"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=2562
  override val CREATE_OFFLINE_PRACTICE_EXPLANATION = "Create and download a practice with your current settings?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1604
  override val CUSTOM = "Custom"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=266
  override val DELETE = "Delete"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=399
  override val DELETE_ACCOUNT = "Delete Account"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=487
  override val DELETE_ACCOUNT_AND_STOP_PAYMENTS_CONFIRM_MESSAGE = "Your account will be PERMANENTLY deleted for ALL of the Down Dog apps, and we will automatically cancel your subscription. Continue?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1220
  override val DELETE_ACCOUNT_ANSWER = "Should you decide to leave us, you can delete your account on the mobile app or on the web app. Please note that once your account is deleted, you will lose your paid subscription as well as your history and saved practices and it cannot be restored!\n\n1. Go to <b>Settings</b>. On mobile, you can get there by tapping the three horizontal lines at the bottom right of the screen. On web, Settings is in the left sidebar. \n2. Under <b>Settings</b>, scroll down to <b>My Data</b>, and tap <b>Delete Account</b>.\n3. When prompted by the pop up box, tap <b>OK</b>."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=485
  override val DELETE_ACCOUNT_CONFIRM_MESSAGE = "Are you sure you want to delete your account? This action cannot be undone. Your account will be permanently deleted for all of the Down Dog apps."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1210
  override val DELETE_ACCOUNT_QUESTION = "How do I delete my account?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1556
  override val DELETE_ACCOUNT_RECONFIRM_MESSAGE = "You are about to permanently delete your account for ALL Down Dog apps. THIS ACTION CANNOT BE UNDONE. Do you want to continue?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=486
  override val DELETE_ACCOUNT_WITHOUT_STOPPING_PAYMENTS_CONFIRM_MESSAGE = "Your account will be permanently deleted for ALL of the Down Dog apps. You will STILL BE CHARGED for your subscription until you cancel it. Continue?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=467
  override val DELETE_HISTORY = "Clear Practice History"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=2565
  override val DELETE_OFFLINE_PRACTICE = "Delete Offline Practice"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1351
  override val DEVICE_LIMIT_ANSWER = "Yes! Make sure to use the same email to log in that you used when you subscribed."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1306
  override val DEVICE_LIMIT_QUESTION = "Does my subscription give me access to workouts on all my devices (laptop, phone, tablet, etc)?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1501
  override val DIDNT_PURCHASE_SUBSCRIPTION = "You have not purchased a subscription."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3946
  override val DISLIKE = "Dislike"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1502
  override val DONT_SEE_SUBSCRIPTION = "I don’t see my subscription"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=629
  override val DOWNLOAD = "Download"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=2557
  override val DOWNLOAD_EXPLANATION = "You can find this practice in the Offline Practices page once the download has completed."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=2559
  override val DOWNLOAD_PRACTICE = "Download Practice"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=2556
  override val DOWNLOAD_STARTED = "Download Started"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=2555
  override fun DOWNLOADING_VIDEO_PROGRESS(p0: Any) = "Downloading... ${p0}%"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3947
  override val EDIT = "Edit"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=491
  override val EDIT_EMAIL = "Edit Email"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=628
  override val EDIT_NAME = "Edit Name"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=492
  override val EDIT_PASSWORD = "Edit Password"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=462
  override val EMAIL = "Email"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=137
  override val EMAIL_AND_PASSWORD = "Email and Password"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=197
  override val ENGLISH_POSE_NAMES = "English pose names"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3370
  override fun ENROLL_CHALLENGE_ENABLE_PUSH_NOTIFICATIONS_INSTRUCTIONS(p0: Any) = "1.  Open your Settings app.\n                                    \n2.  Navigate to Notifications.\n                                    \n3.  Find the ${p0} app, and make sure <b>notifications are enabled.</b>"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3304
  override val ENROLL_CHALLENGE_ENABLE_PUSH_NOTIFICATIONS_PROMPT = "Make sure you have push notifications enabled for Down Dog on your mobile devices."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=146
  override val ENTER_CODE = "Enter Code"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=138
  override val ENTER_EMAIL_ADDRESS = "Enter email address"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=139
  override val ENTER_PASSWORD = "Enter password"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=2170
  override val EQUIPMENT = "Equipment"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=88
  override val ERROR_CONNECTING_TO_APPLE_HEALTH_MESSAGE = "Uh oh! There was an error connecting to the Health app"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=56
  override val ERROR_CONNECTING_TO_GOOGLE_FIT_MESSAGE = "Uh oh!  There was an error connecting to Google Fit."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=57
  override val ERROR_OCCURRED_MESSAGE = "An error occurred.  Please contact us for support."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1198
  override val EXCLUDE_POSES_ANSWER = "<b>Yoga</b>\n\nYes! From your full settings, under Practice, tap <b>View Poses</b>.  From here you can \"dislike\" poses and they will be excluded from any future practice.\n\nOn the <b>View Poses</b> page, you can also \"like\" select poses, which will increase the probability that they will appear in future practices. \n\nPlease note that the Liked and Excluded poses feature is only available for the new practice types of Vinyasa, Restorative, Yin, Gentle, and Hatha.  Older practice types do not support this feature.\n\nPlease also note that liking/disliking poses will impact variety.\n\n<b>HIIT</b>\n\nYes! Under Practice, tap <b>Mix</b>. From there, tap on the + to the left of each body part and you will see a list of exercises come up. Tap on the specific exercises you want to exclude them from your practice.\n\n<b>Prenatal, Barre</b>\n\nWe don’t currently have this feature, but it’s definitely on our list! For now, on the mobile app, you can skip any pose you don't like by swiping left when it comes up. On the web app, click the forward arrow on the bottom left of the screen."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1187
  override val EXCLUDE_POSES_QUESTION = "Can I exclude particular poses from my practice?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1262
  override val EXERCISE_ADVICE = "Exercise advice"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1602
  override val EXERCISE_LIST = "Exercise List"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3254
  override val EXERCISE_NAMES = "Exercise Names"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=267
  override val EXIT = "Exit"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=268
  override val EXIT_PRACTICE = "Exit Practice"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=156
  override val EXIT_PRACTICE_MESSAGE = "Are you sure you want to leave your current practice?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=2720
  override val EXPLICIT_LYRICS = "Explicit Lyrics"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=280
  override val FACEBOOK = "Facebook"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=58
  override val FACEBOOK_AUTHENTICATION_FAILURE_MESSAGE = "Facebook Authentication Failure.  Please try again later."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=147
  override val FACEBOOK_COMMUNITY = "Facebook Community"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=2552
  override val FAILED_PRACTICE_DOWNLOAD = "Failed to download practice"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=2568
  override val FAILED_PRACTICE_DOWNLOAD_EXPLANATION = "Something went wrong while downloading this practice. Please try again."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1308
  override val FAMILY_SHARING_ANSWER = "Unfortunately, we do not support Apple Family Sharing."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1307
  override val FAMILY_SHARING_QUESTION = "Can I share my subscription with family members?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1434
  override val FAQ_PAGE = "FAQ Page"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=269
  override val FAVORITE = "Add to Favorites"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=278
  override val FAVORITES = "Favorites"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1261
  override val FEATURE_REQUEST = "Feature request"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=2153
  override val FEEDBACK_OPTIONAL = "Feedback (optional)"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1274
  override val FEEDBACK_SUBMITTED_TEXT = "Thanks for writing in! "
  
  // https://worker.downdogapp.com/debug/appString?appStringId=2553
  override val FETCHING_PRACTICE = "Creating Practice..."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1417
  override val FITBIT_ANSWER = "No."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1416
  override val FITBIT_QUESTION = "Do the apps connect to FitBit?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=140
  override val FORGOT_PASSWORD = "Forgot Password?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=461
  override val FORGOT_PASSWORD_NEEDS_EMAIL = "Enter your email first in order to reset your password."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1291
  override val FREE_FOR_HEALTHCARE_WORKERS = "Free for Healthcare Workers"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1110
  override val FREE_FOR_SCHOOLS = "Free for Schools"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1395
  override val GET_COMPANIES_MEMBERSHIP = "Get Free Corporate Membership"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1393
  override val GET_HEALTHCARE_MEMBERSHIP = "Get Healthcare Membership"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1392
  override val GET_STUDENT_MEMBERSHIP = "Get Student Membership"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1463
  override val GIFT_ANSWER = "No. We currently do not offer this. "
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3823
  override val GIFT_INSTRUCTIONS_CONTENT_1 = "Buy your Down Dog gift (or gifts!)"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3824
  override val GIFT_INSTRUCTIONS_CONTENT_2 = "Receive a Gift Certificate you can print or send to your friends and family"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3825
  override val GIFT_INSTRUCTIONS_CONTENT_3 = "Recipients can use the QR code in their Certificate to start their year of access whenever they’re ready!"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3780
  override val GIFT_INSTRUCTIONS_TITLE = "How it works:"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1462
  override val GIFT_QUESTION = "Can I gift a subscription?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1440
  override val GO_TO_APPLE_SUPPORT = "Go to Apple Support"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1519
  override val GOAL_STREAK_CAPITALIZED = "Goal Streak"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1514
  override val GOAL_STREAK_NOT_CAPITALIZED = "Goal streak"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=281
  override val GOOGLE = "Google"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=60
  override val GOOGLE_AUTHENTICATION_FAILURE_MESSAGE = "Google Authentication Failure.  Please try again later."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1401
  override val GOOGLE_FIT_ANSWER = "Unfortunately, we no longer support Google Fit.\n\nGoogle made some changes that it made it very hard to continue integrating Google Fit into our offerings."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1400
  override val GOOGLE_FIT_QUESTION = "Do the apps connect to Google Fit?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1495
  override val GUIDED_MEDITATION_AND_BREATHING_ANSWER = "<b>Yoga:</b>\n\n<em>Try Yoga Nidra</em>\n\nYou can find <b>Yoga Nidra</b> in the Yoga app under practice <b>Type</b>. \n\nNote: Yoga Nidra is <b>audio only</b> - there will be no video. \n\nA lot of people enjoy setting the <b>Music</b> to Nature Sounds, Ambient, Brain Waves or Piano and Strings in the app. Try out a few and see which one you prefer!\n\nIf you're new to Yoga Nidra, we recommend listening to it with <b>Instruction Type</b> set to <b>Full Explanation</b> or <b>Default</b>.\n\nYou can also use Yoga Nidra to fall asleep.  After selecting Yoga Nidra as your practice Type, go to <b>Boost</b> and tap <b>Sleep</b>!\n\n\n<b>Prenatal Yoga:</b>\n\nSet your <b>Boost</b> to <b>Breathing</b>! This will give you some breathing exercises at the beginning of your practice, as well as a guided meditation at the end!\n\n\n<b>Meditation:</b>\n\nWe have an entire app dedicated to meditation and breathing!  Check it out at <a href='https://meditation.downdogapp.com/download'>Meditation</a>!\n\nIf you're new to meditation, to receive the most instruction we offer, swipe up the settings view and set your <b>Guidance Amount</b> to <b>Most</b>, and set your <b>Longest Silence</b> to a short time like 30 seconds or 1 minute."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1494
  override val GUIDED_MEDITATION_AND_BREATHING_QUESTION = "How can I get more breathwork and guided meditation in my practice?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=95
  override val HEALTH_DISCLAIMER_AND_WARNING = "Health Disclaimer and Warning"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=97
  override val HEALTH_WAIVER_TEXT = "* Yoga Buddhi Co. offers health and fitness information designed for education purposes only. You should not rely on the information in any Application made by Yoga Buddhi Co. (including but not limited to desktop, mobile, and device Applications, website, blogs, and any social media pages maintained by Yoga Buddhi Co. or Down Dog) as a substitute for professional medical advice, diagnosis, or treatment. We do not in any way guarantee or warrant the accuracy, completeness, or usefulness of any content found in any Application. The use of any information provided on this or any other Application made by Yoga Buddhi Co. is solely at your own risk. We assume no responsibility for injuries suffered while practicing these techniques and Yoga Buddhi Co. shall not be held liable for any damages, circumstances, conditions or injuries that may occur, directly or indirectly, from engaging in any activities or ideas presented in any Application made by Yoga Buddhi Co. Practicing yoga carries risk of injury. We do not recommend yoga exercises without appropriate supervision if you are pregnant or under 18 years of age. By using any Application, you accept all responsibility for your health and any resultant injury or mishap that may affect your well-being or health and/or your baby’s well-being or health in any way. Consult with your physician or health care provider before starting any fitness program, or if you have any questions or concerns about your health. Do not start a fitness program if your physician or healthcare provider advises against it. If you experience faintness, dizziness, pain or shortness of breath at any time while exercising, you should stop immediately and seek immediate medical attention. "
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1391
  override val HEALTHCARE_FREE_UNTIL_JANUARY_1_LONG = "Healthcare providers are eligible for free membership until June 1, 2022!"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1459
  override val HEALTHCARE_MEMBERSHIPS = "Healthcare Memberships"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1753
  override val HERE_ARE_YOUR_SETTINGS = "Here are your settings!"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=785
  override val HIIT = "HIIT"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=758
  override val HIIT_GOOGLE_FIT_DESCRIPTION = "Interval Training Workout"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=282
  override val HISTORY = "History"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1517
  override fun HOURS_SHORT(p0: Any) = "${p0} Hr"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1176
  override val HOW_MANY_INTRO_LESSONS_ANSWER = "There are 9 total lessons in our intro!  \n \nIf you tap <b>Type</b>, you'll see the 3 categories of Vinyasa, Hatha, and Restorative. \n \nThen, once you've selected your <b>Type</b>, tap the number (<b>1, 2, or 3</b>) to do the corresponding lesson.  The numbered lessons are designed to build on one another, so we recommend starting on 1 first.  If the circle has a white background, that is the lesson of that Type that is selected. "
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1168
  override val HOW_MANY_INTRO_LESSONS_QUESTION = "How many Intro lessons are there?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1475
  override val HOW_TO_CANCEL_ANSWER = "<b>How to Manage or Cancel Your Subscription</b> \n\n<em>If you purchased your subscription on the web</em>: \n\n1. Go to <b>Settings</b>. On mobile, you can get there by tapping the three horizontal lines at the bottom right of the screen. On web, Settings is in the left sidebar. \n2. Under <b>Settings</b>, tap <b>Subscription</b>. \n3. Then you should see more info, including how to cancel or change your subscription, including turning off auto-renew. \n\n<em>If you purchased your subscription through the mobile app</em>:\n\nYou can manage your subscription through the <a href=\"https://support.apple.com/en-us/HT202039\" target=\"_blank\">Apple App Store</a> or through the <a href=\"https://support.google.com/googleplay/answer/7018481?co=GENIE.Platform%3DAndroid&hl=en\" target=\"_blank\">Google Play Store</a>. \n\n<b>About Your Subscription</b> \n\nYou will never be charged for a subscription unless you explicitly purchase a membership through our website, Apple, or Google. Subscriptions are found under the email address that you used when you purchased the subscription. If you do not see a subscription listed in your account, it means you do not have a subscription associated with the email address you currently logged in with. It is possible that your subscription may be associated with another email address, and if that is the case, you will need to log out and then log back in under that email address to see your subscription."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1476
  override val HOW_TO_CANCEL_QUESTION = "I want to cancel my subscription."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=99
  override val I_AGREE = "I Agree"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1352
  override val I_HAVE_A_DIFFERENT_QUESTION = "I have a different question"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1264
  override val I_HAVE_A_QUESTION_ABOUT = "I have another question about:"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1383
  override val I_STILL_NEED_HELP = "I still need help"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1387
  override val I_WANT_A_REFUND = "I want a refund."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3292
  override val INCLUDE_POSES_ANSWER = "<b>Yoga</b> \n\nWith our Liked and Excluded poses feature, you can \"like\" select poses, which will increase the probability that they will appear in future practices.  From your full settings, under <b>Practice</b>, tap <b>View Poses</b>. From here you can \"like\" the poses you'd like to see more of in your practices. \n\nFrom <b>View Poses</b>, you can also \"dislike\" poses and they will be excluded from any future practice.\n\nPlease note that the Liked and Excluded poses feature is only available for the new practice types of Vinyasa, Restorative, Yin, Gentle, and Hatha.  Older practice types do not support this feature.\n\nPlease also note that liking/disliking poses will impact variety.\n\n\n<b>HIIT</b> \n\nYes! Under Practice, tap <b>Mix</b>. From there, tap on the + to the left of each body part and you will see a list of exercises come up. Tap on the specific exercises you want to exclude them from your practice.\n\n\n<b>Prenatal, Barre</b>\n\nWe don’t currently have this feature, but it’s definitely on our list! For now, on the mobile app, you can skip any pose you don't like by swiping left when it comes up. On the web app, click the forward arrow on the bottom left of the screen."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3291
  override val INCLUDE_POSES_QUESTION = "Can I include particular poses in my practice?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=155
  override val INSTAGRAM = "Instagram"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=61
  override val INVALID_EMAIL_MESSAGE = "That doesn't appear to be a valid email address. Please try again."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=161
  override val KEEP_TIMELINE_VISIBLE = "Keep timeline visible"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=250
  override val LANGUAGE = "Language"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1426
  override val LATEST_PAYMENT = "Your latest payment was:"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1396
  override val LEARN_MORE = "Learn More"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=168
  override val LENGTH = "Length"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=254
  override val LESS = "Less"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1179
  override val LEVEL_ANSWER = "Because everybody is different, you might try moving up one level and see how that feels.  Some days you may want to go down a level, other days you may feel like trying something new!  Most importantly, listen to the feedback your body gives you, and move slowly and with control.\n\nThe <a href=\"https://www.facebook.com/groups/183894272193568/\" target=\"_blank\">Facebook Community</a>, accessible via the <b>Settings</b> page on the app, is a great resource for getting advice from other people using the app!"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1171
  override val LEVEL_QUESTION = "When should I move up a level?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=344
  override val LIFETIME = "Lifetime"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1465
  override val LIFETIME_ANSWER = "No. We currently do not offer this."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1464
  override val LIFETIME_QUESTION = "Can I purchase a lifetime subscription?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3945
  override val LIKE = "Like"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3047
  override val LIKE_OR_DISLIKE_EXPLANATION = "Like or Dislike poses to improve your future practices"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3199
  override fun LIKED_DISLIKED_COUNT(p0: Any, p1: Any) = "${p0} Liked, ${p1} Disliked"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=2030
  override val LOCK_SCREEN_MEDIA_CONTROLS = "Lock screen media controls"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1729
  override val LOG_IN = "Log In"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1407
  override fun LOGGED_IN_AS(p0: Any) = "You are logged in as ${p0}. "
  
  // https://worker.downdogapp.com/debug/appString?appStringId=310
  override val LOGIN_ERROR = "Login Error"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=141
  override val LOGOUT = "Logout"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=62
  override val LOGOUT_NO_INTERNET_MESSAGE = "It doesn't look like you're connected to the internet. Please reconnect in order to switch accounts."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1456
  override fun LOOK_SCHOOL_PAGE(p0: Any) = "If you are a student or teacher, check out our ${p0}"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1227
  override val LOWER_VIDEO_QUALITY_ANSWER = "You can change between different visual types!  Start a practice, then pause it.  Tap on the <b>Gear icon</b> in the upper right corner. Tap <b>Video Quality</b>. You should see options for higher and lower quality video. This setting is only available on the yoga apps. "
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1217
  override val LOWER_VIDEO_QUALITY_QUESTION = "The videos are taking up too much of my phone’s storage."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=2158
  override val MAKE_SURE_TO_VOTE_FOR_EVERY_OPTION = "Make sure to vote for every option!"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1486
  override val MANAGE_EMAIL_PREFERENCES_ANSWER = "We try not to send too many emails, but please note that emails are a primary way we let our community know of special sales and new features!\n\nYou can control whether you are subscribed or unsubscribed to our emails by going to <b>Settings</b> and then scrolling down to <b>Receive Promo Emails</b> and toggling on or off. "
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1488
  override val MANAGE_EMAIL_PREFERENCES_QUESTION = "How do I manage my email preferences?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1161
  override val MAXIMUM_VERBOSITY_ANSWER = "<b>Yoga and Prenatal Yoga:</b>\n\nYou can turn up the amount of talking by swiping up the settings view and then tapping on <b>Instruction</b>.  Tap <b>Full </b> to receive the most amount of instruction we offer. \n\n<b>Meditation:</b>\n\nTo receive the most instruction we offer, set your <b>Guidance Amount</b> to <b>Most</b>, and set your <b>Longest Silence</b> to a short time like 30 seconds or 1 minute.\n\n<b>HIIT and Barre:</b>\nWe currently do not offer the ability to change the amount of talking on HIIT and Barre. "
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1160
  override val MAXIMUM_VERBOSITY_QUESTION = "I want to hear the most instruction possible when doing the poses."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1661
  override val MEDITATION = "Meditation"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1672
  override val MEDITATION_GOOGLE_FIT_DESCRIPTION = "Meditation Practice"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1431
  override val MEMBERSHIP_DELAYED_START_ANSWER = "No. Subscriptions start as soon as you purchase. \n\nIf you are in a free trial period, you may want to wait until the trial is over to purchase, however if we are running a special sale, this may mean missing out on the best price - we know this can make it a hard decision! \n\nWhether we're running a special sale or not, our website usually offers the best price at the time, so make sure to go to <a href=\"/purchase\">downdogapp.com/purchase</a> when you're ready to purchase!\n"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1430
  override val MEMBERSHIP_DELAYED_START_QUESTION = "Can I delay my subscription start date?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=148
  override val MENU = "Menu"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1163
  override val MINIMUM_VERBOSITY_ANSWER = "<b>Yoga and Prenatal Yoga:</b>\n\nYou can turn down the amount of talking by swiping up the settings view, and then tapping on <b>Instruction</b>. Tap <b>Least</b> to receive the least amount of instruction we offer.\n\n<b>Meditation:</b>\n\nTo receive the least instruction we offer, swipe up the settings view and set your <b>Guidance Amount</b> to <b>Least</b>, and set your <b>Longest Silence</b> to a longer duration such as 5 minutes or more!\n\n<b>HIIT and Barre:</b>\nWe currently do not offer the ability to change the amount of talking on HIIT and Barre. "
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1162
  override val MINIMUM_VERBOSITY_QUESTION = "I want to zone out and hear the least amount of instruction available."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=309
  override fun MINUTES(p0: Any) = "${p0} Minutes"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1254
  override fun MINUTES_SHORT(p0: Any) = "${p0} Min"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1610
  override val MINUTES_WITHOUT_NUMBER = "minutes"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1554
  override val MIRROR_VIDEO = "Mirror Video"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3
  override val MISSING_APPLE_HEALTH_PERMISSIONS_MESSAGE = "Down Dog has been added as a source in the Health app. However, to start logging practices, you will need to enable the Workouts permission for Down Dog from within the Health app."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1583
  override val MIX = "Mix"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1510
  override val MONDAY = "Monday"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=519
  override val MONTH = "month"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=377
  override val MONTHLY = "monthly"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1290
  override val MONTHLY_CAPITALIZED = "Monthly"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1511
  override val MONTHLY_PRACTICES = "Monthly practices"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1516
  override fun MONTHLY_TIME(p0: Any) = "${p0} Time"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1513
  override val MONTHLY_TIME_PRACTICED = "Monthly time practiced"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1482
  override val MONTHLY_TO_YEARLY_ANSWER = "If you have already purchased a monthly subscription, but would prefer a yearly subscription instead, you will need to take a few steps, depending on how you made your current purchase. \n\n<em>If you purchased via our <b>website</b> or <b>Google Play</b></em>: \n\nIf you purchased your current subscription through the web, go to <b>Settings</b> and then <b>Subscriptions</b> to cancel your current subscription. If you purchased through Google Play, you can cancel your current subscription through the <a href=\"https://support.google.com/googleplay/answer/7018481?co=GENIE.Platform%3DAndroid&hl=en\" target=\"_blank\">Google Play Store</a>. After cancelling your current subscription, you can <a href=\"/purchase\">purchase a new subscription through our website</a>. \n\nPlease note, if you choose to cancel and repurchase, we will not be able to offer you a partial refund. In some limited circumstances, you may be eligible for a refund of your current purchase - you can check your refund eligibility by clicking on \"I want a refund\" at <a href=\"/support\">Support</a>. If you are eligible for a refund and have successfully requested and received confirmation of a refund at \"I want a refund\" at <a href=\"/support\">Support</a>, then your current subscription is automatically cancelled. Then you can <a href=\"/purchase\">purchase a new subscription through our website</a>. \n\n<em>If you purchased your subscription through <b>Apple</b></em>: \n\nYou will need to cancel your subscription <a href=\"https://support.apple.com/en-us/HT202039\" target=\"_blank\">through the Apple App Store</a>. Please note, we are unable to issue refunds for purchases made through Apple. After you have canceled your current subscription through Apple, you can <a href=\"/purchase\">purchase a new subscription through our website</a>, which usually has the best price!"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1481
  override val MONTHLY_TO_YEARLY_QUESTION = "I bought a monthly subscription but I want to switch to an annual subscription."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=276
  override val MORE = "More"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=182
  override val MUSIC = "Music"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1140
  override val MUSIC_VOLUME_VS_VOICE_ANSWER = "Once you've started a practice, if you tap the screen and pause your practice, you can adjust the music and voice volume by using the <b>Music/Voice mixing slider</b>.\n\nAfter you have set the Music/Voice ratio that you prefer, then you can use your device to increase or decrease the overall volume."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1139
  override val MUSIC_VOLUME_VS_VOICE_QUESTION = "I can’t hear the instructor’s voice!  Where’s the volume control?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=400
  override val MY_DATA = "My Data"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=429
  override val NEED_INTERNET_FOR_SONG_PREVIEW_MESSAGE = "Uh oh! You need to be connected to the internet in order to play this song preview."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3587
  override val NEW_PASSWORD = "New Password"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=9
  override val NEXT = "Next"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=403
  override val NEXT_PAYMENT = "Next Payment"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=483
  override fun NEXT_PAYMENT_SUBTEXT(p0: Any) = "Next Payment: ${p0}"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1499
  override val NIDRA_AUDIO_ONLY_ANSWER = "Yoga Nidra is <b>audio only</b> - there will be no video!\n\nYoga Nidra is a deeply relaxing guided meditation. You can find it under practice <b>Type</b>, scroll all the way to the bottom. A lot of people enjoy setting the <b>Music</b> to Nature Sounds, Ambient, Brainwaves or Piano & Strings in the app ... try out a few and see which one you prefer! \n\nIf you're new to Yoga Nidra, we recommend listening to it with <b>Instruction Type</b> set to <b>Full Explanation</b> or <b>Default</b>. \n\nYou can also use Yoga Nidra to fall asleep.  After selecting Yoga Nidra as your practice Type, go to <b>Boost</b> and tap <b>Sleep</b>!"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1498
  override val NIDRA_AUDIO_ONLY_QUESTION = "There is no video with my Yoga Nidra practice."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1472
  override val NO_EXCHANGE_FEES_ANSWER = "We do not charge any exchange or conversion fees, but your bank might, so make sure to check with them!"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1471
  override val NO_EXCHANGE_FEES_QUESTION = "Do you charge exchange fees?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=160
  override val NO_FACEBOOK_EMAIL_MESSAGE = "Please allow access to your email address in order to log in with Facebook."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=162
  override val NO_HISTORY_TEXT = "It doesn't look like you've completed any practices yet. Swipe back to the home screen to start your first practice!"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=63
  override val NO_INTERNET_MESSAGE = "We're having trouble communicating with our servers. Please check your internet connection and try again."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1497
  override val NO_MUSIC_OFFLINE_ANSWER = "Because of licensing restrictions, our music will not accompany saved favorites if you are offline.\n\nIf you'd like to play your own music, you can do so through other apps on your device.  However, while the audio cues are turned up to max volume by default on phones and tablets, sometimes this isn't enough to overpower the sound coming from Spotify/iTunes/etc.\n\nIn those cases, we recommend either using an external speaker to play music, or using the web version <a href=\"/web\">downdogapp.com/web</a> on a laptop or desktop, with your music turned down in the background.\n\n"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1496
  override val NO_MUSIC_OFFLINE_QUESTION = "I'm offline and my saved favorite practice has no music."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=2551
  override val NO_OFFLINE_PRACTICES = "You haven't downloaded any practices yet. You can download practices from your history, or create a new one here!"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1478
  override val NO_PARTIAL_REFUND_ANSWER = "Unfortunately, we are unable to accommodate requests for partial or prorated refunds.\n\nIf you have already purchased a subscription, but would like a different subscription, you will need to take a few steps, depending on how you made your current purchase. \n\n<em>If you purchased via our <b>website</b> or <b>Google Play</b></em>: \n\nIf you purchased your current subscription through the web, go to <b>Settings</b> and then <b>Subscriptions</b> to cancel your current subscription. If you purchased through Google Play, you can cancel your current subscription through the <a href=\"https://support.google.com/googleplay/answer/7018481?co=GENIE.Platform%3DAndroid&hl=en\" target=\"_blank\">Google Play Store</a>. After cancelling your current subscription, you can <a href=\"/purchase\">purchase a new subscription through our website</a>. \n\nPlease note, if you choose to cancel and repurchase, we will not be able to offer you a partial refund. In some limited circumstances, you may be eligible for a refund of your current purchase - you can check your refund eligibility by clicking on \"I want a refund\" at <a href=\"/support\">Support</a>. If you are eligible for a refund and have successfully requested and received confirmation of a refund at \"I want a refund\" at <a href=\"/support\">Support</a>, then your current subscription is automatically cancelled. Then you can <a href=\"/purchase\">purchase a new subscription through our website</a>. \n\n<em>If you purchased your subscription through <b>Apple</b></em>: \n\nYou will need to cancel your subscription <a href=\"https://support.apple.com/en-us/HT202039\" target=\"_blank\">through the Apple App Store</a>. Please note, we are unable to accommodate refund requests for purchases made through Apple. After you have canceled your current subscription through Apple, you can <a href=\"/purchase\">purchase a new subscription through our website</a>, which usually has the best price!"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1477
  override val NO_PARTIAL_REFUND_QUESTION = "Can I get a partial refund?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=283
  override val NO_PAST_PURCHASES = "No Past Purchases"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=163
  override val NO_PAST_PURCHASES_MESSAGE = "It doesn't look like you've made any previous purchases. Please contact us if you think this is an error."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1454
  override val NO_REFUND_PRACTICED = "This payment is not refundable since you have completed a practice after purchasing. "
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1455
  override fun NO_REFUND_TIME(p0: Any) = "This payment is not refundable because it took place over ${p0} days ago.  "
  
  // https://worker.downdogapp.com/debug/appString?appStringId=164
  override val NO_SAVED_PRACTICES_TEXT = "Save your favorite practices to replay later."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1224
  override val NO_SOUND_ANSWER = "Here are some steps you can take to try and get sound out of the app:\n\n• Have you made sure that your device itself isn't muted?  You can check this by playing music or audio through a different app.\n• Have you checked that the in-app volume is on?  Once you've started a practice, you can adjust the balance between music and voice volume by pausing your practice, then adjusting the slider near the bottom of the screen. To hear both music and voice, make sure it's adjusted near the middle!\n• Have you tried closing & reopening the app?\n• Have you tried uninstalling and reinstalling the app?\n• Have you tried using the web version of Down Dog (<a href=\"https://www.downdogapp.com/web\" target=\"_blank\">https://www.downdogapp.com/web</a>) to see if you have the same issue?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1214
  override val NO_SOUND_QUESTION = "I have no sound."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=10
  override val NO_STRING = "No"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1388
  override val NO_SUBSCRIPTIONS_SUPPORT_MESSAGE = "There are no active subscriptions on your account."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=284
  override val NONE = "None"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1483
  override val NOT_FREE_ANSWER = "In September 2018, we moved to a new pricing model where we give people a brief free trial with full access to all features, and after that a subscription is required.  This pricing model is applied to all of our apps.\n\n<b>Methods of Purchase</b>\n\n<a href=\"/purchase\">Purchasing through our website</a> will usually get you the best price! You can purchase on our website with a <b>credit card</b> or with <b>PayPal</b>. Purchasing through our website gives you access to everything in all apps, just as if you purchased in-app through Apple or Google. \n\nYou can also purchase in-app through Apple or Google.  Please note, Apple and Google charge commission fees, which is why the in-app price will usually be higher than on our website. \n\nFor purchases made outside of the United States, we do not charge any exchange fees, but your bank might, so make sure to check with them!"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1468
  override val NOT_FREE_QUESTION = "I thought the app was free, why am I being asked to purchase a subscription?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=285
  override val OK = "Ok"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1686
  override fun ONLY_MIX_GROUP(p0: Any) = "Only ${p0}"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=243
  override val OPEN_IN_AMAZON = "Open in Amazon"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=216
  override val OPEN_IN_ITUNES = "Open in iTunes"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=32
  override val OPEN_IN_SPOTIFY = "Open in Spotify"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1257
  override fun OPEN_IN_X(p0: Any) = "Open in ${p0}"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3948
  override val OPEN_LINK = "Open Link"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=2149
  override fun OPTION_X_OF_Y(p0: Any, p1: Any) = "Option ${p0} of ${p1}"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=142
  override val OR = "or"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1111
  override val OTHER = "Other"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1059
  override val OTHER_APPS = "Other Apps"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=194
  override val PACE = "Pace"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=463
  override val PASSWORD = "Password"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=68
  override val PASSWORD_LENGTH_MESSAGE = "Your password should be at least four characters long."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=445
  override val PASSWORDS_MUST_MATCH = "Passwords must match"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3944
  override val PAUSE = "Pause"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=339
  override val PAY_WITH = "Pay with"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=349
  override val PAY_WITH_PAYPAL = "Pay with PayPal"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=480
  override val PAYPAL = "PayPal"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=347
  override val PAYPAL_AUTHORIZATION_ERROR_MESSAGE = "There was an error authorizing your PayPal purchase.  Please try again in a few minutes, or contact customer support."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1419
  override val PAYMENT_ALREADY_REFUNDED = "This payment has already been refunded."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=165
  override val PAYMENT_CONFIRMED_MESSAGE = "Payment Confirmed!"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1474
  override val PAYMENT_METHODS_ANSWER = "Here are the ways you can purchase a subscription!\n\n1) You can purchase through our website with a <b>credit card</b> or with <b>PayPal</b>. \n\nPurchasing through our website gives you access to everything in all apps, just as if you purchased in-app through Apple or Google. The price on our website is usually the best price because there are no Apple/Google commission fees involved.\n\n2) You can purchase in-app through Apple or Google. \n\nPlease note, Apple and Google charge commission fees, which is why the in-app price will usually be higher than on our website.\n\nFor purchases made outside of the United States, we do not charge any exchange fees, but your bank might, so make sure to check with them!"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1473
  override val PAYMENT_METHODS_QUESTION = "What payment methods do you accept?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=465
  override val PAYMENT_PLAN = "Plan"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=317
  override val PER_MONTH = "per month"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=318
  override val PER_YEAR = "per year"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=2539
  override val PILATES = "Pilates"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=2549
  override val PILATES_GOOGLE_FIT_DESCRIPTION = "Pilates Workout"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3943
  override val PLAY = "Play"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=55
  override val PLAY_STORE_PRODUCT_PRICES_MESSAGE = "Error getting product prices from Play Store"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=319
  override val PLAYLIST = "Playlist"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=72
  override val PLAYLIST_TYPE_BUSY = "We had trouble changing your playlist type. Try again in a few seconds."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=73
  override val PLAYLIST_TYPE_NO_INTERNET_MESSAGE = "It doesn't look like you're connected to the internet. Please reconnect in order to change music types."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3049
  override fun POSE_DISLIKED_MESSAGE(p0: Any) = "We will exclude ${p0} from your future practices"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1199
  override val POSE_LIBRARY_ANSWER = "We do not currently offer a pose library, but it's in development!  Stay tuned!\n"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1188
  override val POSE_LIBRARY_QUESTION = "Do you offer a pose library so I can learn more about each pose?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3048
  override fun POSE_LIKED_MESSAGE(p0: Any) = "We will add more ${p0} to your future practices"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1532
  override val POSE_LIST = "Pose List"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3008
  override val POSE_LIST_DESCRIPTION = "Explore all poses below, and designate which ones you’d like to see more or less of in future practices."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3252
  override val POSE_NAMES = "Pose Names"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3071
  override val POSES = "Poses"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=286
  override val PRACTICE = "Practice"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1275
  override val PRACTICE_FEEDBACK = "Practice Feedback"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=166
  override val PRACTICE_SAVED_CONFIRMATION = "Practice added to Favorites!"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1515
  override val PRACTICE_STREAK_NOT_CAPITALIZED = "Practice streak"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1293
  override fun PRACTICES_IN_MONTH(p0: Any) = "${p0} Practices"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=456
  override val PRENATAL = "Prenatal Yoga"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1200
  override val PRENATAL_ANSWER = "Yes! We have a stand alone Prenatal Yoga app  included in all subscriptions that you should check out! You can find Prenatal Yoga on <a href=\"https://play.google.com/store/apps/details?id=com.downdogapp.prenatal\" target=\"_blank\">Android</a> and <a href=\"https://apps.apple.com/us/app/prenatal-yoga-down-dog/id1504152442\" target=\"_blank\">iOS</a>, or at <a href=\"https://prenatal.downdogapp.com/web\" target=\"_blank\">prenatal.downdogapp.com/web</a>. This app will let you tailor your practice by trimester. It also has many of the same boosts that our main yoga app offers, plus some special ones specific to pregnancy."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1189
  override val PRENATAL_QUESTION = "I’m pregnant!  Is there a prenatal option I can select?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1267
  override val PRENATAL_SHORT = "Prenatal"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=2554
  override fun PREPARING_VIDEO_PROGRESS(p0: Any) = "Preparing video... ${p0}% Complete"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=2569
  override val PREPARING_VIDEO_WARNING = "We are preparing your video. Please keep the app open until the download begins or return to the app in a few minutes to initiate the download."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1405
  override val PRICE_DIFFERENCE_ANSWER = "<a href=\"/purchase\">Purchasing through our website</a> avoids commission fees commonly charged by Apple or Google, and will usually get you the best price! You can purchase on our website with a <b>credit card</b> or with <b>PayPal</b>. Purchasing through our website gives you access to everything in all apps, just as if you purchased in-app through Apple or Google. You can use a web subscription on your computer, phone, and tablet.\n\nYou can also purchase a subscription in-app through Apple or Google.  Please note, Apple and Google charge commission fees, which is why the in-app price will usually be higher than on our website. \n\nFor purchases made outside of the United States, we do not charge any exchange fees, but your bank might, so make sure to check with them!"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1404
  override val PRICE_DIFFERENCE_QUESTION = "Why are the in-app prices different from web prices?  Are the memberships different?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=287
  override val PRIVACY_POLICY = "Privacy Policy"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=398
  override val PROMOTIONAL_EMAILS = "Receive Promo Emails"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=351
  override fun RECEIPT_SENT_TO_EMAIL_MESSAGE(p0: Any) = "A receipt will be sent to ${p0}."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1461
  override val RECEIPTS_ANSWER = "Upon purchase of a subscription, we send a receipt to the email address associated with your subscription. \n\nUnfortunately, receipts cannot be resent. If you need to locate the original receipt, we recommend searching in your email for the subject line \"<b>YOUR DOWN DOG RECEIPT</b>.\" Make sure to check your spam folder!  "
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1460
  override val RECEIPTS_QUESTION = "Can you send me a receipt for my subscription purchase?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3799
  override val REDEEM = "Redeem"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3798
  override fun REDEEM_GIFT_INSTRUCTIONS(p0: Any, p1: Any) = "Click the button below to claim 1 year of free access to Down Dog!  The gift (code ${p0}) will be credited to your account ${p1} starting the day you redeem the gift."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3797
  override val REDEEM_GIFT_VIEW_TITLE = "Redeem Your Down Dog Gift Card"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1222
  override val REFUND_ANSWER = "If you purchased your subscription on the web, you can request a refund through our <a href=\"/support\">support</a> page. "
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1212
  override val REFUND_QUESTION = "How can I get a refund?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1424
  override val REFUNDED_ON_WAY = "Your refund is on its way."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=626
  override val REMOVE_FROM_FAVORITES = "Remove from Favorites"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=625
  override val REMOVE_FROM_HISTORY = "Remove from History"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=663
  override val REMOVE_FROM_HISTORY_MESSAGE = "Are you sure you want to remove this practice from your history?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1206
  override val RENAME_FAVORITES_ANSWER = "Yes! Naming an individual practice is a great way to stay organized and it will help you remember why you loved it!\n\nYou can label ANY practices found in your History (regardless of whether it's a favorite or not). Simply tap on a practice in your History, and select <b>Edit Name</b>. "
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1194
  override val RENAME_FAVORITES_QUESTION = "Can I name my favorite practices so I don’t forget which one is which?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3421
  override fun REQUIRED_EMAIL_DOMAIN_ALERT(p0: Any) = "Please sign in using an email address with a ${p0} domain!"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1910
  override val RESET = "Reset"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=154
  override fun RESET_PASSWORD_MESSAGE(p0: Any) = "A link to reset your password has been sent to: ${p0}"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=167
  override val RESUME_PRACTICE = "Resume Practice"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=169
  override val RESUME_PRACTICE_MESSAGE = "Would you like to resume your previous practice?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=2245
  override val RUNNING = "Running"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=2255
  override val RUNNING_GOOGLE_FIT_DESCRIPTION = "Down Dog Running Workout"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=66
  override val SAFARI_OR_MOBILE_BROWSER_WARNING_MESSAGE = "For the best experience on phone or tablet, download the app from the App Store or Play Store.  On a desktop/laptop computer, use Chrome for most reliable playback."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1480
  override val SALE_PRICE_ANSWER = "Whenever we have a sale, you must purchase through our website to get the discounted price.\n\nPurchases can be made on our website using a credit card or PayPal. For international transactions, we do not charge exchange fees, but your bank might, so make sure to check with them!\n\nIf you have already purchased a subscription, and you'd like to take advantage of a special sale we're having, you will have to take a few steps, depending on how you made your current purchase. Please note that a subscription purchase goes into effect immediately upon purchase and will cancel any current subscription. It will not be added onto the end of your current subscription.\n\n<em>If you purchased via our <b>website</b> or <b>Google Play</b></em>: \n\nIf you purchased your current subscription through the web, go to <b>Settings</b> and then <b>Subscriptions</b> to cancel your current subscription. If you purchased through Google Play, you can cancel your current subscription through the <a href=\"https://support.google.com/googleplay/answer/7018481?co=GENIE.Platform%3DAndroid&hl=en\" target=\"_blank\">Google Play Store</a>. After cancelling your current subscription, you can purchase a new subscription through our website. \n\nPlease note, if you choose to cancel and repurchase, we will not be able to offer you a partial refund. In some limited circumstances, you may be eligible for a refund of your current purchase - you can check your refund eligibility by clicking on \"I want a refund\" at <a href=\"/support\">Support</a>. If you are eligible for a refund and have successfully requested and received confirmation of a refund at \"I want a refund\" at <a href=\"/support\">Support</a>, then your current subscription is automatically cancelled. Then you can purchase a new subscription through our website. \n\n<em>If you purchased your subscription through <b>Apple</b></em>: \n\nYou will need to cancel your subscription <a href=\"https://support.apple.com/en-us/HT202039\" target=\"_blank\">through the Apple App Store</a>. Please note, we are unable to accommodate refund requests for purchases made through Apple. After you have canceled your current subscription through Apple, you can purchase a new subscription through our website, which usually has the best price! \n"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1479
  override val SALE_PRICE_QUESTION = "I got an email about a sale! How do I get the sale price?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=198
  override val SANSKRIT_POSE_NAMES = "Sanskrit pose names"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=454
  override val SAVE = "Save"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=529
  override val SAVE_AND_UNLINK = "Save and Unlink"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1204
  override val SAVE_FOR_OFFLINE_ANSWER = "Yes! There are a few ways to save a practice for offline use.  Note this only works on the mobile apps, not web.\n \n<em>Download a practice you've never done before</em>\n\nFrom your home screen, set all of the settings you'd like to have in a practice, then tap on the <b>Down Arrow</b> near the bottom of your screen. This will take you to your <b>Offline Practice</b> screen. If you tap on <b>Create Offline Practice</b> it will create and start downloading a new practice for you with your current settings.\n\n<em>Download a practice you've already done</em>\n\nFrom your home screen, tap on the <b>clock icon</b> near the bottom to see your practice <b>History</b>.  Tap on any practice in this list, and then scroll down and tap <b>Download Practice</b>.  \n\nNote that this will only work for practices in your History that are from the app you are currently using. For example, if you have previously used the Meditation app to do a breathing practice, and you are currently using the Yoga app to view your History, the breathing practice you previously did will appear in your History list. Because this prior practice is from a different app than you are currently viewing, a little blue icon will appear next to this practice reflecting that it is from the Meditation app. You must go to the Meditation app and access your History list from there to have the option of downloading the breathing practice.\n\n<em>View a downloaded practice</em>\n\nFrom your home screen, tap on the <b>Down Arrow</b> near the bottom of your screen. This will take you to your <b>Offline Practice</b> screen. Any practice you see displayed has been downloaded and is ready to be played without an internet connection!\n\nPlease note, because of licensing restrictions, our music will not accompany saved favorites when you are offline."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1192
  override val SAVE_FOR_OFFLINE_QUESTION = "Can I use Down Dog offline?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1205
  override val SAVE_TO_FAVORITES_ANSWER = "Yes!\n\n<em>Save a Practice You Just Completed</em>\n\nIf you’d like to save a practice right after you've finished it, tap <b>Add to Favorites</b> on the post-practice page and it will save it to your <b>Favorites</b> and add a Heart icon to your practice. To access your <b>Favorites</b> , from the <b>History</b>  page  (accessible through the clock icon at the bottom of the main screen), you can click on any practice in your History with a heart icon, or toggle from <b>All</b>  to see only your <b>Favorites</b>.\n\n<em>Save a Previous Practice from your History</em>\n\nIf you’d like to save a practice you did previously, go to your <b>History</b> page (tap the clock icon at the bottom of the home screen). Once you're there, scroll down and then tap on the practice that you want to save. You'll see the words <b>Add to Favorites</b> at the bottom. Pressing that will save the practice to your <b>Favorites</b> and add a Heart icon to your practice. To access your <b>Favorites</b> , from the <b>History</b>  page, you can click on any practice in your History with a Heart icon, or toggle from <b>All</b>  to see only your <b>Favorites</b>.\n\n<em>Fun Fact!</em>\n\nYou can label ANY practices found in your History (regardless of whether it's a favorite or not). Simply tap on a practice in your History, and select <b>Edit Name</b>."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1193
  override val SAVE_TO_FAVORITES_QUESTION = "Is there a way to save my favorite practices?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1458
  override val SCHOOL_MEMBERSHIPS = "School Memberships"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=2150
  override val SCORE = "Score"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=2151
  override val SCORE_HATE_IT = "1 (Hate it)"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=2152
  override val SCORE_LOVE_IT = "5 (Love it)"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3951
  override val SEARCH = "Search"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3108
  override val SEARCH_FOR_A_POSE = "Search for a pose"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3286
  override val SEARCH_FOR_AN_EXERCISE = "Search for an exercise"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1601
  override val SEE_EXERCISES_ON_TIMELINE = "See exercises on timeline"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1587
  override val SEE_POSES_ON_TIMELINE = "See poses on timeline"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=270
  override val SELECT = "Select"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=585
  override val SEND = "Send"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=149
  override val SEND_FEEDBACK = "Send Feedback"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1406
  override val SENDING_FEEDBACK_FAILED = "Sending feedback failed"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=2747
  override val SEQUENCE_LENGTH_INVALID = "Sorry, that practice length is not possible with your current settings. Please select another length."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=297
  override val SET_PASSWORD = "Set Password"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=430
  override val SETTINGS = "Settings"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1177
  override val SETTINGS_FOR_BEGINNERS_ANSWER = "<b>Yoga:</b>\n\n<em>Set Your Level</em>\n\nIf you're new to yoga we recommend starting with Level <b>Beginner 1</b>, found under Practice settings.\n \n<em>Choose Your Practice Type</em>\n\nFor a softer practice that includes standing poses as well as floor poses, try Practice Type <b>Gentle</b>. \n\nFor a restful practice with only floor poses, try <b>Restorative</b>, or <b>Yin</b>, which will allow for the longest holds in the poses. \n\nFor a faster, flowing, more energetic practice, try <b>Vinyasa</b>.\n\nIf you want to flow less, skip the chaturangas, and let the heat build by holding poses longer, try <b>Hatha</b>. \n\n<em>Instruction Level</em>\n\nSet your <b>Instruction</b> level to <b>Full</b> to receive the most detailed instructions. \n\n<em>Set Your Transition Speed and Hold Length</em>\n\nIf you want to slow your practice down further, we recommend adjusting your <b>Transition Speed</b> to <b>Slowest</b> and your <b>Hold Lengths</b> to <b>Longest</b>. Please note older practice types do not support these features.\n\n<em>Extend Your Warmup and Cooldown</em>\n\nFor Practice Types of Vinyasa, Hatha, and Gentle, adjust your <b>Warmup</b> and <b>Cooldown</b> to <b>Extended</b>. Please note older practice types do not support these features.\n\n<em>Like and Exclude Poses</em>\nFor Practice Types of Vinyasa, Hatha, and Gentle, \"like\" poses and see them more often in your practice, or \"dislike\" poses and you'll never see them again.\n\n\n<b>Prenatal Yoga:</b>\n\nIf you're new to yoga we recommend starting with Level <b>Beginner 1</b>, which is found by swiping up in settings view and looking under the Practice settings.\n\nFor a restful practice, we recommend starting out with <b>Restorative</b>, which is all floor work and will allow for the longest holds in the poses. \n\n\n<b>Meditation:</b>\n\nIf you're new to meditation, we recommend keeping your <b>Longest Silence</b> fairly short - the default is 2 minutes, but you can shorten it all the way down to 30 seconds if you'd prefer to have less silence and more guidance.  You can also set your <b>Guidance Amount</b> to <b>Most</b> to get the most instruction we offer!\n\n\n<b>HIIT</b>\n\nOur default settings are a great place to start! \n\nIf HIIT is too challenging on Level 1, try Level 0!  You can also try spending a shorter time on each exercise. You can adjust this by  swiping up in settings view and adjusting your settings under Practice, where you can adjust your Exercise Length. You'll be surprised how big a difference 5 or 10 seconds can make! You can also decrease the length of your overall workout, and increase the length of each Recovery between exercises. \n\nWe offer two practice types, <b>Rotation</b> and <b>Progression</b>. Select <b>Progression</b> to move through different parts of the body always in the same order, or choose <b>Rotation</b>to move through different parts of the body but mix up the order across different practices!\n\n\n<b>Barre:</b>\n\nYou can adjust the difficulty by changing the length of your workout. Experienced athletes should start with 15 or 20 minutes, and work their way up if they want an additional challenge. If you're a beginner, you might want to start with just 5 minutes every day or 10 minutes every other day. Keep it up, and you'll be ready for longer workouts in no time! \n"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1169
  override val SETTINGS_FOR_BEGINNERS_QUESTION = "I don't know where to start! What settings should I select to get the best experience?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1061
  override val SEVEN_MINUTE = "7 Minute"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=150
  override val SHARE = "Share"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1246
  override val SHARE_PRACTICE_ANSWER = "After completing your practice, or from your <b>History</b> or <b>Favorites</b>, tap <b>Share this Practice</b> to get a link to share that practice with your friends. \n\nWhen your friends click the link, they will be taken to the app, and they will get a pop-up message about the saved practice. They should tap <b>Yes</b> to make sure it gets saved to their <b>Favorites</b>!"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1245
  override val SHARE_PRACTICE_QUESTION = "How can I share a practice with my friends?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1181
  override val SHARE_THIS_PRACTICE = "Share this Practice"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1235
  override val SHARED_PRACTICE = "Shared Practice"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3257
  override val SHOW_EXERCISE_NAMES = "Show Exercise Names"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3343
  override val SHOW_LIKE_AND_EXCLUDE_BUTTONS = "Show Like and Exclude Buttons"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=2085
  override val SHOW_OVERLAY = "Show 'Next Up' Text"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=2082
  override val SHOW_POSE_NAME = "Show Pose Names"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1555
  override val SHOW_SUBTITLES = "Show Subtitles"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1728
  override val SIGN_UP = "Sign Up"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=64
  override val SIGN_UP_LOGIN = "Sign Up / Login"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=271
  override val SKIP = "Skip"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1173
  override val SLOWER_PACE_ANSWER = "<b>Yoga:</b>\n\nThere are a few settings you can adjust to slow down your practice - we recommend experimenting with them all!\n\n<em>Transition Speed</em>\n\nSwipe up to see your full settings. Under  <b>Timing</b>, tap on  <b>Transition Speed</b> and set it to <b>Slowest</b> to allow for the most time transitioning between one pose and another, then tap  <b>Select</b>.  Please note older practice types do not support this feature.\n\n<em>Hold Lengths</em>\n\nSwipe up to see your full settings. Under  <b>Timing</b>, tap on <b>Hold Lengths</b> and set it to <b>Longest</b> to allow for the most time in each pose, then tap  <b>Select</b> . Please note older practice types do not support this feature.\n\n<em>Warmup</em> and <em>Cooldown</em>\n\nSet your <b>Warmup</b> and <b>Cooldown</b> to <b>Extended</b>. Please note older practice types do not support these features.\n\n<em>Instruction Level</em>\n\nTo get the most instruction and pointers, you can also set your <b>Instruction</b> level to <b>Full</b>.  \n\n<em>Practice Types</em>\n\nYou might also try setting your practice <b>Type</b> to <b>Gentle</b> or <b>Hatha</b> rather than <b>Vinyasa</b> , to leave out the vinyasa flows/chaturangas.  Or if you’re looking to slow things down even more, set your practice <b>Type</b> to <b>Yin</b>, or <b>Restorative</b>!\n\n\n<b>Prenatal Yoga:</b>\n\nSwipe up in settings view and set your <b>Pace</b> to <b>Slowest</b> to spend the most time in each pose. To get the most instruction and pointers, you can also set your <b>Instruction</b> level to <b>Full Explanation</b>.\n\n<b>HIIT:</b>\n\nYou can change the time spent on each exercise. Swipe up in settings view and under <b>Practice</b>, tap on <b>Exercise Length</b>. You can also adjust the rest time in between exercises by tapping on <b>Recovery</b>. "
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1165
  override val SLOWER_PACE_QUESTION = "How can I slow down the speed of my practice?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=466
  override val SOCIAL = "Social"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=2086
  override val SOMETHING_WENT_WRONG = "Something went wrong"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1533
  override val SONG_LIST = "Song List"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=288
  override val SONGS_PLAYED = "Songs Played"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=272
  override val START = "Start"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1600
  override val START_PRACTICE = "Start Practice"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=89
  override val START_PRACTICE_NO_INTERNET_MESSAGE = "It doesn't look like you're connected to the internet. Please reconnect in order to start a new practice."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=2090
  override val START_SHARED_PRACTICE = "Would you like to start this shared practice?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1507
  override val STAT_TYPE_SUBTITLE = "What would you like to see?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1506
  override val STAT_TYPE_TITLE = "Choose your stat"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1390
  override val STUDENTS_FREE_UNTIL_JANUARY_1_LONG = "Students and teachers are eligible for free membership!"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1268
  override val SUBJECT_COLON = "Subject:"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=273
  override val SUBMIT = "Submit"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1266
  override val SUBMITTING = "Submitting..."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=477
  override val SUBSCRIPTION = "Subscription"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1223
  override val SUBSCRIPTION_RENEWAL_PRICE_ANSWER = "If you leave on autorenew, then yes! If you turn off autorenew, you will have the chance to resubscribe at whatever rate is available when you’re ready to resubscribe. Please note that for transactions made through Paypal, you cannot turn autorenew back on after you have turned it off."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1213
  override val SUBSCRIPTION_RENEWAL_PRICE_QUESTION = "Does my subscription renew at the same price I purchased it?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1389
  override fun SUBSCRIPTIONS_SUPPORT_MESSAGE(p0: Any) = "You are logged in as ${p0}. Here are the subscriptions on your account:"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1288
  override val SUBTITLES_ANSWER = "Closed captions/subtitles are available for every language we offer! \n\nOn the mobile app:\n1. Start a practice  \n2. Tap the screen, and then take the <b>Gear icon</b>.  Toggle <b>Show Subtitles</b> to the <b>ON</b> position\n\nOn the web app:\n1. Start a practice  \n2. Click the <b>cc</b> icon located at the bottom right of your screen to turn on the transcriptions\n\nTo turn the transcriptions off, just tap <b>cc</b> again."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1287
  override val SUBTITLES_QUESTION = "Do you have closed captions/subtitles?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=452
  override val SUCCESS = "Success"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1509
  override val SUNDAY = "Sunday"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=500
  override val SUPPORT = "Support"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=2333
  override val SUPPORT_MANAGE_EXPECTATIONS_TEXT = "We are a very small company, and get thousands of messages per day, so we can't promise a response, but we'll do our best to get back to you promptly!  Note that we prioritize messages from paying customers."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1754
  override val SWIPE_DOWN_TO_START_PRACTICING = "Swipe down to start practicing"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=262
  override val TAP_TO_BEGIN = "Tap to begin"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1260
  override val TECH_ISSUES = "Tech issues"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=289
  override val TERMS_OF_USE = "Terms of Use"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=303
  override val THANKS = "Thanks"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=2157
  override val THANKS_FOR_FILLING_OUT_THE_SURVEY = "Thanks for filling out the survey!"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1265
  override val THIS_FORM_FIELD_IS_REQUIRED = "Please fill out this field"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=615
  override val TIMELINE = "Timeline"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=2050
  override val TOGGLE_SHOW_MORE_SETTINGS = "Toggle show more settings"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=2590
  override val TOO_MANY_DOWNLOADS = "You have reached the maximum number of simultaneous downloads. Please wait for one to finish and try again."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1248
  override val TOTAL_PRACTICES = "Total Practices"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1523
  override val TOTAL_PRACTICES_CAPITALIZED = "Total Practices"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1524
  override val TOTAL_PRACTICES_NOT_CAPITALIZED = "Total practices"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1252
  override val TOTAL_TIME = "Total Time"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1521
  override val TOTAL_TIME_CAPITALIZED = "Total Time"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1522
  override val TOTAL_TIME_NOT_CAPITALIZED = "Total time practiced"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1137
  override val TROUBLESHOOTING = "Troubleshooting"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=251
  override val TRY_AGAIN = "Try Again"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1155
  override val TURN_OFF_MUSIC_ANSWER = "You can turn the in-app music off by swiping up the settings view and tapping <b>Music</b>, then tapping <b>None</b> for the music type!  \n \nIf you'd like to play your own music, you can do so through other apps on your device.  However, while the audio cues are turned up to max volume by default on phones and tablets, sometimes this isn't enough to overpower the sound coming from Spotify/iTunes/etc.\n \nIn those cases, we recommend either using an external speaker to play music, or using the web version (https://www.downdogapp.com/web) on a laptop or desktop, with your music turned down in the background."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1154
  override val TURN_OFF_MUSIC_QUESTION = "I’d prefer to listen to my own music as I practice.  How do I turn off the music completely?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=2088
  override val UNABLE_TO_LOAD_PLAYBACK_URL = "Whoops, we couldn't load the video"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1276
  override val UNABLE_TO_OPEN_LINKED_PRACTICE = "The linked practice is not associated with this account"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=998
  override val UNKNOWN_CAST_RECEIVER_NAME = "unknown device"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1641
  override val UNLINK_FROM_APPLE = "Unlink from Apple"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1642
  override val UNLINK_FROM_APPLE_MESSAGE = "Set a password to unlink from Apple."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=504
  override val UNLINK_FROM_FACEBOOK = "Unlink from Facebook"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=506
  override val UNLINK_FROM_FACEBOOK_MESSAGE = "Set a password to unlink from Facebook."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=505
  override val UNLINK_FROM_GOOGLE = "Unlink from Google"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=507
  override val UNLINK_FROM_GOOGLE_MESSAGE = "Set a password to unlink from Google."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1398
  override val UNLINK_GOOGLE_FACEBOOK_ANSWER = "1. Go to <b>Settings</b>. On mobile, you can get there by tapping the three horizontal lines at the bottom right of the screen. On web, Settings is in the left sidebar. \n2. Under <b>Account</b>, tap <b>Unlink from Google</b> (or <b>Unlink from Facebook</b>) and fill in the new password you'd like to use in the Password and Confirm Password fields \n3. Tap <b>Save</b>"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1397
  override val UNLINK_GOOGLE_FACEBOOK_QUESTION = "How can I unlink Google/Facebook, and use an email and password instead?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=418
  override val UPDATE = "Update"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1226
  override val VIDEO_ACCIDENTALLY_MIRRORED_ANSWER = "If your entire practice is flipped, check to make sure you don't have the mirroring function turned on! Here’s how to check!\n\nOn the mobile app:\n1. Start a practice\n2. At the top right of your screen, tap the <b>Gear icon</b>.  Toggle <b>Mirror Video</b> to on or off to flip the display \n\nOn the web app:\n1. Start a practice\n2. At the bottom right of your screen, click the <b>third icon from the left</b> to flip the display\n"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1216
  override val VIDEO_ACCIDENTALLY_MIRRORED_QUESTION = "The video is reversed from what the voice is telling me."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1225
  override val VIDEO_FREEZING_ANSWER = "Here are a few things you can try:\n\n1. Uninstall and reinstall the app\n\n2. Switch to lower quality video. Start a practice, then pause it. Tap on the <b>Gear icon</b> in the upper right corner. Tap <b>Video Quality</b>. You should see options for higher and lower quality video. This setting is only available on the yoga apps.\n\n3. Web only: Try a different browser. Down Dog works best with Safari, Firefox, and Chrome. "
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1215
  override val VIDEO_FREEZING_QUESTION = "My screen froze midway through the practice."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1201
  override val VIDEO_MODEL_ANSWER = "<b>Yoga, Prenatal, Barre</b>\n\nCurrently we only have one model for each of our apps.  As we continue to grow, we’d love to be able to add more choices for you!\n\n<b>HIIT</b>\n\nCurrently we offer two models in the HIIT app!"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1190
  override val VIDEO_MODEL_QUESTION = "Is there more than one model I can watch on the video?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=670
  override val VIDEO_QUALITY = "Video Quality"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=2558
  override val VIEW_OFFLINE_PRACTICE = "View Offline Practice"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1491
  override val VIEW_PLAYLIST_ANSWER = "After completing a practice, or from a practice on your <b>History</b> page, tap <b>Song List</b> to see a playlist of the songs that played during your practice!"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1490
  override val VIEW_PLAYLIST_QUESTION = "What songs played during my practice?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=3109
  override val VIEW_POSES = "View Poses"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=75
  override val VISUAL_TYPE_NO_INTERNET_MESSAGE = "It doesn't look like you're connected to the internet. Please reconnect in order to change visual types."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=290
  override val VOICE = "Voice"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=2159
  override val VOICE_ACTOR_NON_ENGLISH_SURVEY_INTRO = "We're adding new voice actors to the app and we want your input! Tell us how you like each of the voices below by scoring them from 1 to 5. Please ignore any technical/sound quality issues and focus on their actual voice and how natural the translation sounds!"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=2154
  override val VOICE_ACTOR_SURVEY_INTRO = "We're adding new voice actors to the app and we want your input! Tell us how you like each of the voices below by scoring them from 1 to 5. Please ignore any technical/sound quality issues and focus on their actual voice!"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1423
  override val WANT_REFUND_CONFIRMATION = "Would you like this payment refunded? Your subscription will be cancelled and you will immediately lose access."
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1508
  override val WEEK_START_TITLE = "When should your week start?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1518
  override val WEEKLY_GOAL = "Weekly Goal"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1504
  override val WEEKLY_GOAL_SELECTOR_TITLE = "Set a weekly goal"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1505
  override val WEEKLY_GOAL_SUBTITLE = "How many practices will you aim to do each week?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=569
  override val WHATS_UP = "What's up?"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1256
  override fun X_PERCENT_COMPLETE(p0: Any) = "${p0}% Complete"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=378
  override val YEARLY = "yearly"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1289
  override val YEARLY_CAPITALIZED = "Yearly"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1731
  override val YES_SIGN_UP = "Yes, Sign Up"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=291
  override val YES_STRING = "Yes"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1060
  override val YOGA = "Yoga"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=501
  override val YOGA_FOR_BEGINNERS = "Yoga for Beginners"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=757
  override val YOGA_GOOGLE_FIT_DESCRIPTION = "Down Dog Yoga Practice"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1493
  override val YOGA_NIDRA_INFO_ANSWER = "Yoga Nidra is a deeply relaxing guided meditation. In the main yoga app, you can find it under Practice <b>Type</b>.  \n\nNote:  <b>Yoga Nidra is audio only</b> - there will be no video.  \n\nA lot of people enjoy setting the <b>Music</b> to Nature Sounds, Ambient, Brain Waves or Piano and Strings in the app. Try out a few and see which one you prefer!\n\nIf you're new to Yoga Nidra, we recommend listening to it with <b>Instruction Type</b> set to <b>Full Explanation</b> or <b>Default</b>. \n\nYou can also use Yoga Nidra to fall asleep! After selecting Yoga Nidra as your practice Type, go to <b>Boost</b> and set your boost to <b>Sleep</b>!"
  
  // https://worker.downdogapp.com/debug/appString?appStringId=1492
  override val YOGA_NIDRA_INFO_QUESTION = "What is Yoga Nidra?"
}
